import React, { useEffect, useState,useContext,useCallback } from "react";
import Select from "components/select/select";
import Button from "components/button/button";
import {
  TemplateColorOptions,
  TemplateControl,
  // colorOptions,
  // stepsInfo,
  templatesPlaceholder,
  templatesPlaceholderNP,
  templatesPlaceholderTG,
  templatesPlaceholderNPTG,
} from "utils/constant";
import _ from "lodash";
import update from "immutability-helper";
import PopInfo from "components/info-popup/pop-info";
import { useTranslation } from "react-i18next";
import { LangContext } from "context/language";
import useEmblaCarousel from 'embla-carousel-react';
import { motion,AnimatePresence } from 'framer-motion';
import { TEMPLATE_NAME_1, TEMPLATE_NAME_2, TEMPLATE_NAME_3, TEMPLATE_NAME_4, TEMPLATE_NAME_5 } from "constants/options";
// import Toggle from "components/toggle/toggle";
const animation = {
  initial: {
    opacity: 0,
    translateY: 25
  },
  whileInView: {
    opacity: 1,
    translateY: 0
  },
  transition: {
    duration: 0.8
  }
};

export default function TemplatePanel({
  onChangeColor,
  onChangeTemplate,
  color,
  // onChangeToggleImage,
  show_image,
  profileType,
}) {
  const [templates, setTemplates] = useState([]);
  const {t} = useTranslation();
  const {stepsInfo, colorOptions} = useContext(LangContext)
  const onShowOtherImages = (index, page, current) => {
    let payload = _.clone(templates);
    let payloadImages = (current.images || []).map((obj, index) => {
      if (page === index) {
        return { ...obj, active: true };
      } else {
        return { ...obj, active: false };
      }
    });

    if (payload) {
      let data = update(payload, {
        [index]: {
          images: {
            $set: payloadImages,
          },
        },
      });
      setTemplates(data);
    }
  };

  useEffect(() => {
    let templateMod = templatesPlaceholderNP;

    if(profileType === "team" || profileType === "group") {
      if (show_image) {
        templateMod = templatesPlaceholderTG;
      } else {
        templateMod = templatesPlaceholderNPTG;
      }
    } else {
      if (show_image) {
        templateMod = templatesPlaceholder;
      }
    }

    let obj = _.find(templateMod, { key: color?.key });
    if (!_.isEmpty(obj)) {
      setTemplates(obj.templates);
    }
  }, [color, show_image]);

  return (
    <div className="w-full px-4 md:px-10 py-5 4md:px-23 4md:py-12.5">
      {/* header */}
      <header className="w-full">
        <div className="w-full grid grid-cols-3 9sm:grid-cols-6 gap-4 2smd:gap-16.5 items-center">
          {stepsInfo.map((obj, index) => (
            <div
              className="w-full flex flex-col justify-center 2smd:justify-start 2smd:flex-row 2smd:space-x-4.5 2smd:items-center"
              key={index}>
              {obj.icon}
              <div className="steps-resume-responsive">
                <p className="text-sm text-primary font-semibold">
                {obj.step}</p>
                {/* // index + 1 */}
                <p className="text-sm font-medium text-darkerGray">
                  {obj.label}
                </p>
              </div>
            </div>
          ))}
        </div>
      </header>
      {/* body */}
      <div className="w-full mt-14">
        {/* header Title */}
        <div className="w-full grid justify-start">
          <div className="w-full flex flex-row gap-x-2 items-center">
            <h1 className="text-2xl text-lightBlack font-semibold">
              {t('selectYourResumeTemplate')}
            </h1>
            <PopInfo containerClass="relative" type="resume_template" />
          </div>
          <p className="text-darkerGray mt-3">
            {t('YouCanReplaceTemplate')}
          </p>
        </div>
        {/* end header title */}
        <div className="w-full 4sm:flex 4sm:items-center 4sm:justify-between">
          <div className="w-full flex justify-center mt-6">
            <div className="w-full flex justify-start flex-row space-x-3 items-center">
              <p className="text-sm font-medium text-darkerGray">
                {t('select')} {`${JSON.parse(localStorage.getItem('user_data'))?.profile?.dateFormat ? 'Colour' : 'Color'} `}
              </p>
              <Select
                customOptions={true}
                optionComponent={{
                  Option: TemplateColorOptions,
                  Control: TemplateControl,
                }}
                formContainer="w-75"
                options={colorOptions}
                placeholder={t("selectColor")}
                defaultValue={color}
                onChange={onChangeColor}
                height={50}
              />
            </div>
          </div>
          {/* <div className="w-full 3md:w-14/20 flex items-center mt-6 justify-end">
            <div className="flex space-x-6">
              <div>
                <Toggle
                  checked={show_image}
                  name="dateFormat"
                  onChange={(e) => onChangeToggleImage(e?.target?.checked)}
                />
              </div>
              <div>
                <p className="text-lg font-medium text-lightBlack">
                  Show/Hide Images
                </p>
              </div>
            </div>
          </div> */}
        </div>
        {/* template selector */}
        {/* <div className="w-full mt-8.6">
          <div className="w-full flex justify-center flex-row gap-8.6 flex-wrap">
            
          </div>
        </div> */}

        <div className="pt-[7.5rem] pb-[3.75rem] px-6">
              <motion.h1 className="text-center font-medium text-3xl md:text-5xl mb-9" {...animation}>  {t('exploreMorePeople')}</motion.h1>
                <motion.div className="container m-auto flex flex-col gap-8" 
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}>
                    <AnimatePresence>
                      <HorizontalScroller items={templates} onShowOtherImages={onShowOtherImages} onChangeTemplate={onChangeTemplate}/>
                </AnimatePresence>
                </motion.div> 
                <motion.div {...animation} className="flex items-center justify-center mt-9">
              </motion.div>
            </div>
        {/* end: */}
      </div>
    </div>
  );
}

function HorizontalScroller({ items,groupKey,onChangeTemplate=()=>{},onShowOtherImages=()=>{}  }) {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    dragFree: true,
    loop: false, // no looping
  })

  const scrollPrev = useCallback(() => emblaApi?.scrollPrev(), [emblaApi])
  const scrollNext = useCallback(() => emblaApi?.scrollNext(), [emblaApi])
  const {t} = useTranslation();
  const templateName = (name)=>{
    switch(name){
      case TEMPLATE_NAME_1:
        return 'Classic Resume';
      case TEMPLATE_NAME_2:
        return 'Marquee Resume';
      case TEMPLATE_NAME_3:
        return 'Template Name 3';
      case TEMPLATE_NAME_4:
        return 'Minimalist Resume';
      case TEMPLATE_NAME_5:
        return 'Acting Resume';
      default:
        return name;
        
    }
  }

  return (
    <motion.div
      data-role="people-group"
      className="w-full max-w-[86.25rem] mx-auto"
      key={groupKey}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <div className="flex flex-row items-center justify-between mb-4">
        <div className="font-bold text-lg md:text-[1.75rem]">{groupKey}</div>
        <div className="flex flex-row items-center gap-4">
          <button
            onClick={scrollPrev}
            className="border-[1.5px] border-onbg rounded-full w-[2.625rem] h-[2.625rem] flex items-center justify-center cursor-pointer transition-all duration-300 hover:bg-primary hover:text-white hover:border-primary outline-none"
          >
            <svg
              width="8"
              height="12"
              viewBox="0 0 8 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="mr-[1.5px]"
            >
              <path
                d="M6.06211 1.1001L2.15206 5.01015C1.60533 5.55688 1.60532 6.44331 2.15206 6.99005L6.06211 10.9001"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </button>

          <button
            onClick={scrollNext}
            className="border-[1.5px] border-onbg rounded-full w-[2.625rem] h-[2.625rem] flex items-center justify-center cursor-pointer transition-all duration-300 hover:bg-primary hover:text-white hover:border-primary outline-none"
          >
            <svg
              width="7"
              height="12"
              viewBox="0 0 7 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="ml-[1.5px]"
            >
              <path
                d="M1.1625 1.1001L5.07255 5.01015C5.61928 5.55688 5.61928 6.44331 5.07255 6.99005L1.1625 10.9001"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </button>
        </div>
      </div>

      <div ref={emblaRef} className="overflow-hidden">
        <div className="flex gap-6 select-none">
           {items.map((obj, index) => {
              let current = _.find(obj.images, { active: true });
              return (
                <div
                  className="flex-[0_0_25%] px-3"
                  key={index}>
                  <div className="w-full relative cursor-pointer template-hover">
                    <div className="w-full h-full bg-white bg-opacity-40 absolute top-0 rounded-t-md hidden-template-hover">
                      <div className="w-full h-full grid justify-center items-center">
                        <Button
                          buttonName={t('selectThisTemplate')}
                          buttonTextClass="text-xs font-semibold text-white"
                          buttonRadius="6px"
                          buttonClass="bg-primary px-17.5 py-4.6"
                          onClick={() => onChangeTemplate(obj.name)}
                        />
                      </div>
                    </div>
                    <img
                      src={current.image}
                      className="rounded-t-md"
                      alt="resume-template-one"
                    />
                  </div>
                  <div className="w-full py-4.5 px-3 border-t border-resumeBorder template-hover-footer">
                    <div className="w-full flex flex-wrap justify-between items-center">
                      <p className="text-lightBlack text-lg font-medium">
                        {templateName(obj.name)}
                      </p>
                      <div className="flex flex-start gap-1.5">
                        {(obj.images || []).map((image, subIndex) => (
                          <button
                            key={subIndex}
                            onClick={() =>
                              onShowOtherImages(index, subIndex, obj)
                            }
                            className={`w-2 h-2 rounded-full ${
                              image.active ? "bg-primary" : "bg-gray"
                            } `}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </motion.div>
  )
}
